export var ActivityType = /*#__PURE__*/function (ActivityType) {
  ActivityType["ADDED"] = "added";
  ActivityType["DELETED"] = "deleted";
  ActivityType["MODIFIED"] = "modified";
  ActivityType["COMPOSITE"] = "composite";
  return ActivityType;
}({});

/**
 * TODO: not sure if this is used anywhere
 * @deprecated
 */